module.exports = __webpack_public_path__ + "static/media/cl_logo_color.baba75f7.webp";